<template>
  <component
    :is="componentFile"
    v-bind="{ ...customProps }"
    v-on="{ ...events }"
  />
</template>

<script>
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'DynamicModalComponent',
  mixins: [
    cardsModel,
  ],
  props: {
    componentName: {
      type: String,
      required: true,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    },
    events: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: this.model,
    };
  },
  computed: {
    componentFile() {
      return () => import(/* webpackPrefetch: true */ `./../${this.componentName}.vue`);
    },
  },
  mounted () {
    if (this.$props.componentName) {
      this.loadComponent();
    }
  },
  methods: {
    loadComponent () {
      this.componentFile()
        .catch(err => {
          console.error('Failed to load component', err);
          this.showComponent = false;
        });
    },
  },
};
</script>
